import ReactGA from "react-ga4";

const TRACKING_ID = "G-QR1NV06WHT";

// Only initialize in production
const isProduction = process.env.NODE_ENV === "production";

export const initGA = () => {
	if (isProduction) {
		ReactGA.initialize(TRACKING_ID);
	}
};

export const trackPageView = (path: string) => {
	if (isProduction) {
		ReactGA.send({ hitType: "pageview", page: path });
	}
};

export const trackEvent = (category: string, action: string, label?: string) => {
	if (isProduction) {
		ReactGA.event({
			category,
			action,
			label
		});
	}
};
